import styled from "styled-components";
import { layout } from "../../../package.json";

export const ContainerButton = styled.button`
  margin: 0px 10px;
  display: flex;
  justify-content: center;
  max-width: 250px;
  flex: 1;
  align-items: center;
  gap: 10px;
  color: var(----primary);
  cursor: pointer;
  font-size: 12px;

  div {
    display: flex;
    flex-direction: column;
    gap: 2px;

    @media (max-width: ${layout.mobile}) {
      span + span {
        display: none;
      }
    }
  }
`

export const ContainerStore = styled.div`
    color: var(----primary);
    font-size: 12px;
    flex:1;
    max-width: 250px;
    display: flex;
    flex-direction: column;
    gap: 2px;

    @media (max-width: ${layout.mobile}) {
      span + span {
        display: none;
      }
    }
  
`